module.exports = __webpack_public_path__ + "static/media/audit-trail.4bf45bc9.svg";